import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import { memberCardIsRegisteredValidator } from '@shared/core/validators/member-card.shared.validator';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';

@Component({
    selector: 'shared-form-for-member-card',
    templateUrl: './form-for-member-card.shared.component.html',
    styleUrls: ['./form-for-member-card.shared.component.scss']
})
export class FormForMemberCardComponent extends FormTypesComponent implements OnInit {
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
        public membersService: Services.MembersService,
        public modalsService: Services.ModalsService,
    ) {
        super(config, formBuilder);
        this.formName = 'member-card';
    }

    ngOnInit(): void {
        this.loading$ = this.controllers.members.isMakingRequestsAsStatus$();

        this.formControl = this.formBuilder.group({
            memberCard: [
                { value: '', disabled: false },
                {
                    validators: Validators.compose([
                        Validators.required,
                        Validators.minLength(this.minLength),
                        Validators.maxLength(this.maxLength),
                    ]),
                    asyncValidators: Validators.composeAsync([
                        memberCardIsRegisteredValidator(this.membersService),
                    ]),

                }
            ],
        });

        if (this.config.memberCard && this.config.memberCard.maxLength) {
            this.labelMemberCard = `${this.labelMemberCard} ( ${this.config.memberCard.maxLength} )`;
        }
    }
    public get minLength(): number {
        return this.config.memberCard && this.config.memberCard.minLength || 10;
    }

    public get maxLength(): number {
        return this.config.memberCard && this.config.memberCard.maxLength || 10;
    }

    public get cardNumber(): string {
        return this.formControl.controls.memberCard.value;
    }

    public handleFormSubmit($event: Event): void {
        const formValues = this.getFormValues();
        // this.membersService.forgotPasswordResetInit(formValues.email);
        this.controllers.members.initSignIn(`${formValues.memberCard}`, OLO.Enums.LOGIN_TYPE.MEMBER_CARD_NUMBER_BASED_LOGIN);
    }

    public handleSkipStepClick($event: Event): void {
        this.controllers.members.skipMemberCardSignUp();
    }

    public handleErrorButtonClick($event: Event): void {
        this.controllers.members.goToLoginAuthStep();
    }
}
